import { Interval } from 'date-fns';

import { TradeEntity } from '@/common/types/entities';
import { ScheduleAlert } from '@/features/scheduleAlerts/types';
import { ProjectContributorGroupFragment } from '@/graphql/__generated__/graphql';

export type CapacityAggregationMode = 'people' | 'activities';

export type SummaryRowCellMouseEvent = {
  type: 'mouseenter' | 'mouseleave';
  mouseEvent: MouseEvent;
  isDaily: boolean;
  startDate: Date;
  endDate: Date;
};

export type WorkerThresholdExceededAlertType = 'contributorGroup' | 'project';

export interface WorkerThresholdExceededAlert
  extends ScheduleAlert<WorkerThresholdExceededAlertType> {
  orderIds: string[];
  contributorGroupId?: string;
  threshold: number;
  title: string; // contributor group or project name
  actualWorkerCount: number;
}

export function isWorkerThresholdExceededAlert(
  alert: ScheduleAlert,
): alert is WorkerThresholdExceededAlert {
  return alert.type === 'contributorGroup' || alert.type === 'project';
}

export type DailyTradeSummary = {
  tradeId: string;
  color: string;
  name: string;
  count: number;
  workerCount: number;
  contributorGroups: Map<string, ProjectContributorGroupFragment>;
  orderIds: Set<string>;
};

export type CapacitiesData = {
  dailyTradeSummaries: Record<string, DailyTradeSummary[]>;
  maxTradeAppearances: Record<string, number>;
  maxTradeWorkerCounts: Record<string, number>;
  maxContributorGroupWorkerCounts: Record<
    string,
    Map<string, { workers: number; orderIds: string[] }>
  >;
  timeRange: Interval;
  tradesUsedForSummaries: Map<string, TradeEntity>;
};

export type TradesSummaryByDate = Record<string, Record<string, DailyTradeSummary>>;
export type TradesProjectCount = Record<string, number>;

export type AggregationResult = {
  key: string | null;
  count: number;
};
